/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ProgressState} from './progress.reducers';

// Selector functions
const stateData =
  createFeatureSelector<ProgressState>('ss-cord.progress');

// Create Selectors
export const heightChartData = createSelector(
  stateData,
  (state: ProgressState) => state.height.chartData
);
export const heightChartTableData = createSelector(
  stateData,
  (state: ProgressState) => state.height.tableData
);

export const weightChartData = createSelector(
  stateData,
  (state: ProgressState) => state.weight.chartData
);
export const weightChartTableData = createSelector(
  stateData,
  (state: ProgressState) => state.weight.tableData
);

export const dailyFoodChartData = createSelector(
  stateData,
  (state: ProgressState) => state.dailyFood.chartData
);

export const weeklyFoodChartData = createSelector(
  stateData,
  (state: ProgressState) => state.weeklyFood.chartData
);
export const weeklyFoodChartTableData = createSelector(
  stateData,
  (state: ProgressState) => state.weeklyFood.tableData
);

export const bmiChartData = createSelector(
  stateData,
  (state: ProgressState) => state.bmi.chartData
);
export const bmiChartTableData = createSelector(
  stateData,
  (state: ProgressState) => state.bmi.tableData
);

export const bmiGoalFilter = createSelector(
  stateData,
  (state: ProgressState) => state.bmiGoalFilter
);

export const adultBmiGoalFilter = createSelector(
  stateData,
  (state: ProgressState) => state.adultBmiGoalFilter
);


export const dailyPAChartData = createSelector(
  stateData,
  (state: ProgressState) => JSON.parse(JSON.stringify(state.dailyPA.chartData))
);

export const weeklyPAChartData = createSelector(
  stateData,
  (state: ProgressState) => state.weeklyPA.chartData
);
export const paTableData = createSelector(
  stateData,
  (state: ProgressState) => state.weeklyPA.tableData
);

export const dailySTChartData = createSelector(
  stateData,
  (state: ProgressState) => state.dailyST.chartData
);

export const weeklySTChartData = createSelector(
  stateData,
  (state: ProgressState) => state.weeklyST.chartData
);
export const stTableData = createSelector(
  stateData,
  (state: ProgressState) => state.weeklyST.tableData
);

export const journalChartData = createSelector(
  stateData,
  (state: ProgressState) => state.journal.chartData
);
export const journalChartTableData = createSelector(
  stateData,
  (state: ProgressState) => state.journal.tableData
);

